import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Users, Building, Phone, DollarSign } from 'lucide-react';
import { extractDateFromFilename } from '../lib/utils';

const SummaryCard = ({ summaryData, filename }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('uk-UA', { 
      style: 'currency', 
      currency: 'UAH',
      minimumFractionDigits: 0 
    }).format(amount);
  };

  const summaryItems = [
    {
      title: 'Всього співробітників',
      value: summaryData.totalEmployees,
      icon: Users,
      color: 'text-blue-600',
      bgColor: 'bg-blue-100'
    },
    {
      title: 'Всього ліфтів',
      value: summaryData.totalElevators,
      icon: Building,
      color: 'text-purple-600',
      bgColor: 'bg-purple-100'
    },
    {
      title: 'Всього заявок',
      value: summaryData.totalApplications,
      icon: Phone,
      color: 'text-orange-600',
      bgColor: 'bg-orange-100'
    },
    {
      title: 'Середня зарплата',
      value: formatCurrency(summaryData.averageSalary),
      icon: DollarSign,
      color: 'text-green-600',
      bgColor: 'bg-green-100'
    }
  ];

  return (
    <Card className="mb-6 shadow-lg border border-gray-200">
      <CardHeader>
        <CardTitle className="text-xl font-bold text-gray-900 text-center">
          Загальні показники ({summaryData.period || extractDateFromFilename(filename)}) 
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          {summaryItems.map((item, index) => (
            <div key={index} className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
              <div className="flex items-center space-x-3">
                <div className={`w-10 h-10 ${item.bgColor} rounded-full flex items-center justify-center`}>
                  <item.icon className={`w-5 h-5 ${item.color}`} />
                </div>
                <div className="flex-1">
                  <p className="text-xs text-gray-600 mb-1">{item.title}</p>
                  <p className="text-lg font-bold text-gray-900">{item.value}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-6 pt-4 border-t border-gray-200">
          <div className="flex justify-between items-center">
            <span className="text-gray-600 font-medium">Загальний фонд оплати праці:</span>
            <span className="text-2xl font-bold text-green-700">
              {formatCurrency(summaryData.totalPayroll)}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SummaryCard;